"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var media_devices_service_1 = require("./media-devices.service");
var constants_1 = require("../utilities/constants");
var utils_1 = require("../utilities/utils");
var i_vc_cms_service_1 = require("./i-vc-cms.service");
var webrtc_service_1 = require("./webrtc.service");
var VcService = /** @class */ (function () {
    function VcService(mediaDevicesService, vcCmsService, webRTC) {
        this.mediaDevicesService = mediaDevicesService;
        this.vcCmsService = vcCmsService;
        this.webRTC = webRTC;
        this.vcParticipants = new Map();
    }
    VcService.prototype.publish = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            audioSource: this.mediaDevicesService.selectedMicrophone,
                            videoSource: account.activeVideo ? this.mediaDevicesService.selectedCamera : null,
                            publishAudio: account.activeAudio,
                            publishVideo: account.activeVideo,
                        };
                        this.webRTC.createPublisher(config);
                        return [4 /*yield*/, this.webRTC.publish()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VcService.prototype.requestMediaStream = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var constraints;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!account.activeVideo) return [3 /*break*/, 2];
                        constraints = {
                            video: {
                                deviceId: this.mediaDevicesService.selectedCamera
                            }
                        };
                        return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constraints)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    VcService.prototype.clearMediaStream = function (mediaStream) {
        if (mediaStream) {
            mediaStream.getTracks().forEach(function (track) {
                track.stop();
            });
        }
    };
    VcService.prototype.sendMessage = function (message, sessionId) {
        var chatMessage = utils_1.getChatMessage(message);
        this.vcCmsService.sendMessage(sessionId, chatMessage);
        this.webRTC.signal(JSON.stringify(chatMessage), [], 'chat');
    };
    VcService.prototype.getUserInfo = function (connectionData) {
        var data = JSON.parse(connectionData);
        return this.vcParticipants.get(data.currentUserId);
    };
    VcService.prototype.disconnect = function () {
        this.webRTC.disconnect();
    };
    VcService.prototype.onRefresh = function (mediaStream) {
        var _this = this;
        window.addEventListener('beforeunload', function () { return _this.clearStream(mediaStream); }, false);
    };
    VcService.prototype.clearStream = function (mediaStream) {
        this.clearMediaStream(mediaStream);
        this.disconnect();
    };
    VcService.prototype.parseParticipantsInfo = function (connectionData) {
        var _this = this;
        // filtering not subscriber users,
        var users = connectionData.users.filter(function (user) { return !constants_1.AppConstants.isSubscriber(user.connectionRole); });
        this.roles = connectionData.roles;
        connectionData.users
            .filter(function (user) { return constants_1.AppConstants.isSubscriber(user.connectionRole); })
            .forEach(function (user) { return _this.vcParticipants.set(user.USERID, user); });
        if (users) {
            var vcParticipantsRoleMapping_1 = new Map();
            var participantsRoleMapping_1 = new Map();
            this.roles.forEach(function (role) { return vcParticipantsRoleMapping_1.set(role, []); });
            users.forEach(function (user) {
                _this.vcParticipants.set(user.USERID, user);
                if (user.userRole) {
                    if (!vcParticipantsRoleMapping_1.has(user.userRole)) {
                        vcParticipantsRoleMapping_1.set(user.userRole, []);
                    }
                    vcParticipantsRoleMapping_1.get(user.userRole).push(user);
                }
                else {
                    vcParticipantsRoleMapping_1.get(_this.roles[user.userRoleId]).push(user);
                }
            });
            vcParticipantsRoleMapping_1.forEach(function (value, key) {
                !!value.length && participantsRoleMapping_1.set(key, value);
            });
            return participantsRoleMapping_1;
        }
    };
    VcService.prototype.checkParticipantsAudioVideo = function (staffParticipants, participants, judge) {
        var _this = this;
        var checkParticipantAudioMuted = function (participant) {
            return !_this.webRTC.isMyOwnConnection(participant.connection) && participant.manager &&
                participant.manager.stream && participant.manager.stream.audioActive;
        };
        var checkParticipantVideoOff = function (participant) {
            return !_this.webRTC.isMyOwnConnection(participant.connection) && participant.manager &&
                participant.manager.stream && !participant.manager.stream.videoActive;
        };
        var isStaffUnMuted = staffParticipants.some(checkParticipantAudioMuted);
        var isParticipantUnMuted = participants.some(checkParticipantAudioMuted);
        var isJudgeUnMuted = judge && checkParticipantAudioMuted(judge);
        var isStaffVideoOff = staffParticipants.some(checkParticipantVideoOff);
        var isParticipantVideoOff = participants.some(checkParticipantVideoOff);
        var isJudgeVideoOff = judge && checkParticipantVideoOff(judge);
        return {
            isSomeoneUnMuted: isStaffUnMuted || isParticipantUnMuted || isJudgeUnMuted,
            isSomeoneVideoOff: isStaffVideoOff || isParticipantVideoOff || isJudgeVideoOff
        };
    };
    VcService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [media_devices_service_1.MediaDevicesService,
            i_vc_cms_service_1.IVCCmsService,
            webrtc_service_1.WebRTCService])
    ], VcService);
    return VcService;
}());
exports.VcService = VcService;
//# sourceMappingURL=vc.service.js.map